import { render, staticRenderFns } from "./GroupData.vue?vue&type=template&id=58f97850&lang=pug"
import script from "./GroupData.js?vue&type=script&lang=js&external"
export * from "./GroupData.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports